// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ClaimItemDocumentDTO } from './claim-item-document-dto';
import { ClaimProposalDTO } from './claim-proposal-dto';

/**
 * 
 * @export
 * @interface ClaimItemProposalDTO
 */
export interface ClaimItemProposalDTO {
    /**
     * 
     * @type {string}
     * @memberof ClaimItemProposalDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemProposalDTO
     */
    claimProposalId: string;
    /**
     * 
     * @type {ClaimProposalDTO}
     * @memberof ClaimItemProposalDTO
     */
    claimProposal?: ClaimProposalDTO;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemProposalDTO
     */
    claimItemId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemProposalDTO
     */
    explanation?: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemProposalDTO
     */
    amount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimItemProposalDTO
     */
    settled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemProposalDTO
     */
    settledSource?: ClaimItemProposalDTOSettledSourceEnum;
    /**
     * 
     * @type {Array<ClaimItemDocumentDTO>}
     * @memberof ClaimItemProposalDTO
     */
    documents?: Array<ClaimItemDocumentDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemProposalDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemProposalDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ClaimItemProposalDTOSettledSourceEnum {
    SUPPLIER = 'SUPPLIER',
    TENANT = 'TENANT'
}



